import(/* webpackMode: "eager" */ "/home/u488987580/domains/monetizx.agency/hbuilds/source/MonetizX1start/src/app/page.tsx");
